export default __webpack_public_path__ + "static/media/student-login.729e91c9.svg";